import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Tooltip, Popconfirm } from 'antd';
import ActionInfo from 'assets/Action.svg';
import Hypen from 'assets/hypen-triple.png';
import DeleteIcon from 'assets/Delete.svg';
import Calendar from 'assets/leave-calendar-blue.svg';
import { Flex, Text, Box, Image } from 'atoms';
import { deleteLeave } from 'store/leaveSlice';

const Container = styled(Flex)`
	justify-content: space-between;
	align-items: center;
	height: 56px;
	margin: 5px 20px;
	padding: 10px 20px;
	border-radius: 4px;
	border-bottom: 1px solid ${(props) => props.theme.colors.Platinum};
	background-color: ${(props) => props.theme.colors.white};
	@media (max-width: 370px) {
		padding: 10px;
		margin: 5px 8px;
	}
`;

const Label = styled(Text)`
	margin: 5px 10px;
	font-size: 8px;
	word-wrap: break-word;
	color: ${(props) => props.theme.colors.BattleShipGray};
`;

const Dataa = styled(Text)`
	font-size: 10px;
	overflow-wrap: break-word;
	text-align: center;
	line-height: 1.5;
`;

const ActionIcon = (props) => {
	switch (props?.status) {
		case 'Pending':
			return DeleteIcon;
		case 'Rejected':
			return ActionInfo;
		case 'Approved':
			return Hypen;
		case 'Partially Accepted':
			return ActionInfo;
		default:
			return ActionInfo;
	}
};

const Action = styled.img.attrs((props) => ({
	src: ActionIcon(props),
	alt: props.status,
}))``;

const StatusColor = (props) => {
	switch (props?.status) {
		case 'Pending':
			return props.theme.colors.YellowOrg;
		case 'Rejected':
			return props.theme.colors.TartOrange;
		case 'Approved':
			return props.theme.colors.Emerald;
		case 'Partially Accepted':
			return props.theme.colors.FuchsiaCrayola;
		default:
			return props.theme.colors.black;
	}
};

const Status = styled(Dataa)`
	color: ${(props) => StatusColor(props)};
`;

export default function LeaveInfoCard({ leaveDate, status, dateRange }) {
	let comment;
	let leaveId;
	const dispatch = useDispatch();
	const { Data = [] } = useSelector((state) => state.leave);

	Data.map((dt) =>
		dt.date.map((ar) => {
			if (ar.date === leaveDate) {
				comment = dt.comment;
				leaveId = dt.leave_id;
			}

			return 0;
		})
	);

	function handleStatus(stats) {
		if (stats === 'Rejected') {
			return (
				<Tooltip
					trigger="click"
					color="blue"
					overlayStyle={{ fontSize: '10px' }}
					title={comment === null ? 'No Comment' : comment}
					placement="topRight"
				>
					<Box mt="5px" style={{ cursor: 'pointer' }}>
						<Action status={status} heigth={15} width={15} />
					</Box>
				</Tooltip>
			);
		}
		if (stats === 'Pending') {
			return (
				<Popconfirm
					title="Are you sure to delete this Leave?"
					onConfirm={() => dispatch(deleteLeave(leaveId))}
					okText="Yes"
					cancelText="No"
					placement="topRight"
					style={{ fontSize: '10px' }}
				>
					<Box mt="5px" style={{ cursor: 'pointer' }}>
						<Action status={status} heigth={15} width={15} />
					</Box>
				</Popconfirm>
			);
		}

		return (
			<Box mt="5px" style={{ cursor: 'pointer' }}>
				<Action status={status} heigth={15} width={15} />
			</Box>
		);
	}

	return (
		<Container dateRange={dateRange}>
			<Flex justifyContent="center" alignItems="center" p="0 10px">
				<Image src={Calendar} />
			</Flex>
			<Flex justifyContent="space-between" width="50%" mr="80px">
				<Flex flexDirection="column" alignItems="center" width="100px">
					<Label>Leave Date</Label>
					<Dataa mt="5px">{moment(leaveDate).format('DD-MMM-YYYY')}</Dataa>
				</Flex>
				<Flex flexDirection="column" alignItems="center" width="70px">
					<Label>Status</Label>
					<Status mt="5px" status={status}>
						{status}
					</Status>
				</Flex>
			</Flex>
			<Flex flexDirection="column" alignItems="center" mr="20px">
				<Label>Action</Label>
				{handleStatus(status)}
			</Flex>
		</Container>
	);
}

LeaveInfoCard.propTypes = {
	leaveDate: PropTypes.string,
	status: PropTypes.string,
	dateRange: PropTypes.bool,
};
